// Module
var code = "<div data-moduleicon=\"fpd-icon-layers\" data-defaulttext=\"Manage Layers\" data-title=\"modules.manage_layers\"> <div class=\"fpd-scroll-area\"> <div class=\"fpd-list\"></div> </div> </div>";
// Exports
module.exports = code;